import styled from 'styled-components';

import { Box } from '../../../../shared/Typhography';

import { RevenueTable } from './Components';

const Container = styled.div`
  margin-top: 150px;
`;

export default function InsightsScreen() {
  return (
    <Container>
      {/* <Box> <RevenueGraphs /> </Box> */}
      <Box>
        <RevenueTable />
      </Box>
    </Container>
  );
}
